import { InputLabel, type InputLabelProps, Typography } from '@mui/material';

export interface FieldLabelProps extends Omit<
  InputLabelProps,
  'children' | 'shrink'
> {
  label: string;
  subtitle?: string;
}
export const FieldLabel: React.FC<FieldLabelProps> = ({
  label,
  htmlFor,
  sx,
  required,
  subtitle,
  ...props
}) => {
  return (
    <InputLabel
      shrink={false}
      htmlFor={htmlFor}
      {...props}
      sx={{ mb: 1, ...sx }}
    >
      <Typography variant="subtitle2" color="text.primary" noWrap>
        {label} {required && <span>*</span>}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" noWrap>
          {subtitle}
        </Typography>
      )}
    </InputLabel>
  );
};
